import React from "react";
import footlogoimg from "../assets/images/GuideUni_logo_white.png";

const Footer = () => {
    return (
        <div class="footer footer-bg-1">
            <div class="container-fluid">
                <div class="container pt-3">
                    <div class="row">
                        <div class="col-md-6 col-sm-12 footer-logo">
                            <a href="/"><img src={footlogoimg} alt="" /></a>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <ul class="footer-list-right-align">
                                <li>
                                    <a href="#"><i class="ri-phone-fill"></i> Contact Us </a>
                                </li>
                                <li>
                                    <a href="#"><i class="ri-sign-fill"></i> Sign In </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12">

                            <div class="row">
                                <div class="col-md-12">
                                    <p class="pt-3">With GuideUni, universities gain a powerful platform designed to make international
                                        student recruitment seamless and efficient.</p>

                                </div>
                                <div class="col-md-12">
                                    <ul class="fot-list-media">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="ri-facebook-fill"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="ri-twitter-fill"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="ri-instagram-fill"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="ri-linkedin-fill"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">
                                                <i class="ri-youtube-fill"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div>

                            </div>
                        </div>
                        <div class="col-md-8 col-sm-12">
                            <div class="row">
                                <div class="col-md-4 col-sm-12">
                                    <h3 class="display-6">Platform</h3>
                                    <ul class="fot-list-v-one">
                                        <li>
                                            <a href="javascript:void(0)">Universities</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Recruiters</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Aggregators</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <h3 class="display-6">Resource Center</h3>
                                    <ul class="fot-list-v-one">
                                        <li>
                                            <a href="javascript:void(0)"> How It Works</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Pricing</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Blog</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-4 col-sm-12">
                                    <h3 class="display-6">Company</h3>
                                    <ul class="fot-list-v-one">
                                        <li>
                                            <a href="index.html">About Company</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Careers</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)">Contact Us</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div class="container-fluid footer-bg-2">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-sm-12 ">
                            <span class="pt-c-10 d-block copy-r-text">© 2025 GuideUni. All Rights Reserved.</span>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <ul class="fot-list-h-two">
                                <li>
                                    <a href="privacy-policy.html">Trust & security </a>
                                </li>
                                <li>
                                    <a href="cookie-policy.html">Terms of Use </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Privacy Policy</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Cookies Policy</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
